import React from "react";
import PublicNav from "./PublicNav";
import Footer from "./Footer";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-cloud">
      <PublicNav />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
